<template>
    <div>
        <v-overlay :value="overlayError" style="z-index: 1001;">
            <v-alert colored-border border="left" color="red" light>
                <v-row align="center">
                    <v-col class="grow"> {{ overlayErrorMessage }} </v-col>
                    <v-col class="shrink">
                        <v-icon @click="overlayError = false">mdi-close-circle</v-icon>
                    </v-col>
                </v-row>
            </v-alert>
        </v-overlay>
        <v-dialog v-model="dialogConfirnCancelCircular" max-width="400">
            <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on"
                    style="
                                                                                                                                                                                                                                                                                                                                                                                                                                                        display: none
                                                                                                                                                                                                                                                                                                                                                                                                                                                        z-index: 1;
                                                                                                                                                                                                                                                                                                                                                                                                                                                        position: absolute;
                                                                                                                                                                                                                                                                                                                                                                                                                                                        font-family: Kanit;
                                                                                                                                                                                                                                                                                                                                                                                                                                                        font-size: 1em;
                                                                                                                                                                                                                                                                                                                                                                                                                                                        right: 6%;
                                                                                                                                                                                                                                                                                                                                                                                                                                                        top: 10%;
                                                                                                                                                                                                                                                                                                                                                                                                                                                        width: 37px;
                                                                                                                                                                                                                                                                                                                                                                                                                                                        height:37px;
                                                                                                                                                                                                                                                                                                                                                                                                                                                      "
                    fab x-small dark class="mt-2 mb-2 red">
                    <v-icon class="ml-2" left>mdi-close</v-icon>
                </v-btn>
            </template>
            <v-card>
                <v-card-title>
                    <p>ยืนยันการนำหนังสือเวียนออก</p>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col align="center" cols="12">
                            <v-btn style="z-index: 1; font-family: Kanit; font-size: 1.3em" rounded
                                class="pt-6 pb-6 pl-6 pr-6 blue--text text--darken-4 white mr-4" @click="stillSameGroup"
                                dark>
                                ยกเลิก
                            </v-btn>
                            <v-btn style="z-index: 1; font-family: Kanit; font-size: 1.3em" rounded
                                class="pt-6 pb-6 pl-6 pr-6 blue darken-4" @click="removeAllGroup" dark>
                                ยืนยัน
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-checkbox id="circularLetterreceivenote" v-model="circularLetter" :label="`หนังสือเวียน`" :disabled="isDisabled"
            :append-icon="circularLetter ? 'mdi-pencil' : ''" @click:append="editCircularLetter"
            class="font-weight-bold"></v-checkbox>
        <v-dialog v-model="addforwarddialog" width="500" persistent>
            <v-card>
                <v-card-title class="subtitle-1 text-left font-weight-bold pb-0">
                    <v-row>
                        <v-col cols="12" class="d-flex">
                            เลือกผู้ดำเนินการ
                            <v-spacer></v-spacer>
                            <v-icon class="ml-auto" style="cursor: pointer;" @click="closeDialog" absolute top
                                right>mdi-close</v-icon>
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-card-title class="subtitle-1 text-left font-weight-bold pt-0">
                    <v-form ref="formCircularCheck" v-model="valid" lazy-validation>
                        <v-row>
                            <v-col cols="12" class="pt-0 pb-0">
                                <v-radio-group @change="getGroup" class="ml-3" v-model="operatorSelect" row
                                    :rules="inputRules" hide-details="auto">
                                    <v-radio label="ทั้งหมด" value="all"></v-radio>
                                    <v-radio label="ศูนย์/ฝ่าย" value="department"></v-radio>
                                    <v-radio label="บุคคล" value="person"></v-radio>
                                </v-radio-group>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-title>
                <v-card-text>
                    <v-form ref="formSelected" v-model="valid" lazy-validation>
                        <v-row>
                            <v-col cols="12" class="pt-0 pb-0 d-flex">
                                <v-autocomplete v-model="selectCircular" :loading="loading" :items="items"
                                    :search-input.sync="searchCircular" class="mx-4" flat no-filter hide-no-data
                                    hide-details="auto" label="เรียน" id="selectSI" :rules="inputRules">
                                    <template v-slot:selection="{ item }">
                                        <v-list max-width="240px">
                                            <v-list-item-content>
                                                <v-list-item-title style="overflow: visible; font-size: 1em">
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <div v-bind="attrs" v-on="on"
                                                                style="max-width: 240px; font-size: 1em"
                                                                class="text-start text-truncate">
                                                                {{ item.description }}
                                                            </div>
                                                        </template>
                                                        <span>{{ item.description }}</span>
                                                    </v-tooltip>
                                                </v-list-item-title>
                                                <v-list-item-subtitle style="font-size: 0.95em; overflow: visible">
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <div v-bind="attrs" v-on="on"
                                                                style="max-width: 240px; font-size: 0.95em"
                                                                class="text-start text-truncate">
                                                                {{ item.position }}
                                                            </div>
                                                        </template>
                                                        <span>{{ item.position }}</span>
                                                    </v-tooltip>
                                                </v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list>
                                    </template>
                                    <template v-slot:item="{ item }">
                                        <v-list max-width="240px">
                                            <v-list-item-content>
                                                <v-list-item-title style="overflow: visible; font-size: 1em">
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <div v-bind="attrs" v-on="on"
                                                                style="max-width: 240px; font-size: 1em"
                                                                class="text-start text-truncate">
                                                                {{ item.description }}
                                                            </div>
                                                        </template>
                                                        <span>{{ item.description }}</span>
                                                    </v-tooltip>
                                                </v-list-item-title>
                                                <v-list-item-subtitle style="font-size: 0.95em; overflow: visible">
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <div v-bind="attrs" v-on="on"
                                                                style="max-width: 240px; font-size: 0.95em"
                                                                class="text-start text-truncate">
                                                                {{ item.position }}
                                                            </div>
                                                        </template>
                                                        <span>{{ item.position }}</span>
                                                    </v-tooltip>
                                                </v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list>
                                    </template>
                                </v-autocomplete>

                                <v-btn rounded light style="font-family: Kanit; width: 100px" class="ml-auto mt-2"
                                    @click="addCircular" color="white" id="addCircular">
                                    เพิ่ม</v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                    <v-row>
                        <v-col>
                            <v-card outlined v-for="(circularItem, i) in selectCircularList" class="mt-1 mb-0"
                                v-bind:key="'forward' + i">
                                <v-btn id="deleteForwarded" color="red darken-4" dark x-small absolute top right fab text
                                    @click="removeCircular(i)" style="right: -0.4%; top: -1%">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                                <v-card-text class="mt-n3 mb-n6">
                                    <v-textarea style="font-size: 1em" auto-grow rows="1" v-model="circularItem.position"
                                        placeholder="เรียน" class="font-weight-bold mx-0" :id="'forwardposition' + i"
                                        :append-icon="'mdi-comment'" @click:append="
                                            () => (circularItem.isShowRemark = !circularItem.isShowRemark)
                                        " readonly></v-textarea>
                                    <v-row class="ml-0 mt-n4 mb-3" v-if="circularItem.type != 'org'">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <span v-bind="attrs" v-on="on">
                                                    {{ circularItem.name }}
                                                </span>
                                            </template>
                                            <span>{{ circularItem.name }}</span>
                                        </v-tooltip>
                                    </v-row>
                                    <v-textarea v-if="circularItem.isShowRemark" v-model="circularItem.remark" auto-grow
                                        rows="1" placeholder="หมายเหตุ" class="mb-4 font-weight-bold"></v-textarea>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row>
                        <v-col cols="12" class="pt-0 pb-0 d-flex">
                            <v-textarea v-model="RemarkForward" auto-grow rows="1" placeholder="หมายเหตุ"
                                class="mx-4 font-weight-bold"></v-textarea>
                            <v-btn rounded light style="font-family: Kanit; width: 100px"
                                class="ml-auto pr-4 pl-4 align-self-center" @click="saveCircular" color="white"
                                id="toDocument">
                                ยืนยัน</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>

            </v-card>
        </v-dialog>
    </div>
</template>
<script>

import axios from 'axios'

export default {
    name: "CircularComponent",
    created() {
        this.urlApiMainProcess = this.$VUE_APP_URL_API_MAIN_PROCESS;
        this.urlApiUserMgnt = this.$VUE_APP_URL_API_USER_MGNT;
        console.log('this.data', this.data)
        this.loadData(this.docType, this.docId)
        this.circularLetter = this.isCircular
        this.isFirstTimeLoaded = this.isfirstTime
        console.log('this.circularLetter ', this.circularLetter)
        if (!this.circularLetter) {
            console.log('mouted', this.circularLetter)
            this.isFirstTimeLoaded = false
        }

    },
    // mouted() {
    //     if (!this.circularLetter) {
    //         console.log('mouted', this.circularLetter)
    //         this.isfirstTime = false
    //     }
    // },
    props: {
        docType: { type: String, required: true },
        docId: { type: String, required: true },
        isCircular: { type: Boolean, default: false },
        isfirstTime: { type: Boolean, default: false },
        isDisabled: { type: Boolean, default: false },
    },
    data: () => ({
        circularLetter: false,
        addforwarddialog: false,
        isCloseDialog: false,
        circularLetterOldValue: false,
        inputRules: [v => !!v || "กรุณากรอกข้อมูล"],
        operatorSelect: null,
        loading: false,
        selectCircular: null,
        searchCircular: null,
        items: [],
        departmentMasterList: [],
        selectCircularList: [],
        overlayError: false,
        overlayErrorMessage: "",
        RemarkForward: null,
        valid: false,
        selectCircularSave: [],
        dialogConfirnCancelCircular: false,
        isStillSameGroup: false,
        urlApiMainProcess: null,
        isFirstTimeLoaded: false,
    }),
    watch: {
        searchCircular(val) {
            this.searchItems(val);
        },
        isCircular(val) {
            this.circularLetter = val
        },
        circularLetter(newVal, oldValue) {
            if (this.isFirstTimeLoaded) {
                this.isFirstTimeLoaded = false;
                this.circularLetter = newVal;
                return;
            }
            if (this.isCloseDialog) {
                this.isCloseDialog = false;
                this.circularLetter = newVal;
                return;
            }
            if (this.isStillSameGroup) {
                this.isStillSameGroup = false;
                this.circularLetter = newVal;
                return;
            }
            this.circularLetterOldValue = oldValue
            if (newVal) {
                this.selectCircularList = [];
                this.selectCircularList.push(...this.selectCircularSave)
                this.addforwarddialog = true;
            } else {
                this.dialogConfirnCancelCircular = true;
            }

        }
    },

    methods: {
        async loadData(docType, docId) {
            console.log('docType', docType)

            if (docId !== null && docId !== undefined) {

                let config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                        API_ACCESS_KEY: this.$VUE_APP_ACCESS_KEY_USER_MNGT,
                    },
                };

                await axios
                    .get(
                        this.urlApiMainProcess + `circular/${docType}/${docId}`,
                        config
                    )
                    .then((response) => {
                        let result = response.data.result
                        console.log(result)

                        for (let item of result.departmentPerson) {
                            let userList = []
                            for (let person of item.forwardPerson) {
                                userList.push({
                                    index: 1,
                                    mainContact: {
                                        userMsgId: person.mainContact.userMsgId,
                                        name: person.mainContact.name,
                                        positionLabel: person.mainContact.positionLabel,
                                    },
                                    secretary: [],
                                })
                            }

                            let orgData = {
                                id: item.id,
                                name: "",
                                position: item.departmentName,
                                type: "org",
                                userList: userList,
                                remark: item.remark,
                                isShowRemark: false,
                            }
                            this.selectCircularSave.push(orgData);

                        }
                        for (let item of result.forwardPerson) {
                            let personData = {
                                id: item.mainContact.userMsgId,
                                name: item.mainContact.name,
                                position: item.mainContact.positionLabel,
                                type: "person",
                                userList: [{
                                    index: 1,
                                    mainContact: {
                                        userMsgId: item.mainContact.userMsgId,
                                        name: item.mainContact.name,
                                        positionLabel: item.mainContact.positionLabel,
                                    },
                                    secretary: [],
                                }],
                                remark: item.remark,
                                isShowRemark: false,
                            }
                            this.selectCircularSave.push(personData);
                        }

                        this.remarkForward = result.remarkForward
                        this.operatorSelect = result.isAll ? "all" : null



                        // this.circularLoaded = response.data
                    })
                    .catch((error) => {
                        console.log(error)
                    });
            }
            let data = await this.getResult()
            this.$emit('Result', { isSelect: this.circularLetter, data: data })
        },
        stillSameGroup() {
            this.isStillSameGroup = true;
            this.dialogConfirnCancelCircular = false;
            this.circularLetter = true;
        },
        async removeAllGroup() {
            this.selectCircularSave = [];
            this.dialogConfirnCancelCircular = false;
            let data = await this.getResult()
            this.$emit('Result', { isSelect: this.circularLetter, data: data })
        },
        editCircularLetter() {
            this.circularLetterOldValue = this.circularLetter;
            this.selectCircularList = [];
            this.selectCircularList.push(...this.selectCircularSave)
            this.addforwarddialog = true;
        },
        async saveCircular() {

            if (this.selectCircularList.length == 0) {
                if (!this.$refs.formCircularCheck.validate()) {
                    return;
                }
            }

            if (this.operatorSelect != "all" && this.selectCircularList.length == 0) {
                this.overlayError = true;
                this.overlayErrorMessage = "กรุณาเลือกส่งต่ออย่างน้อย 1 คน"
                return;

            }

            this.selectCircularSave = [];
            this.selectCircularSave.push(...this.selectCircularList)
            let data = await this.getResult()
            this.$emit('Result', { isSelect: this.circularLetter, data: data })
            this.addforwarddialog = false

        },
        async getResult() {

            let forwardPerson = []
            let departmentPerson = []
            for await (let item of this.selectCircularSave) {
                if (item.type == "person") {
                    let user = item.userList[0]
                    user.remark = item.remark
                    forwardPerson.push(user)
                }
                else if (item.type == "org") {
                    let departmentObj = {
                        id: item.id,
                        departmentName: item.position,
                        forwardPerson: item.userList,
                        remark: item.remark
                    }
                    departmentPerson.push(departmentObj);
                }
            }
            let resultForSave = {
                forwardPerson: forwardPerson,
                departmentPerson: departmentPerson,
                isAll: this.operatorSelect == "all",
                remarkForward: this.RemarkForward,
            }
            return resultForSave;

        },
        async checkDuplicate(type, id) {

            if (type == 'org') {

                let checkExisting = this.selectCircularList.findIndex(x => x.id == id && x.type == 'org');
                if (checkExisting > -1) {
                    return true;
                }
                return false;

            } else if (type == 'person') {

                let checkExisting = this.selectCircularList.findIndex(x => x.id == id && x.type == 'person');
                if (checkExisting > -1) {
                    return true;
                }

                let isDup = false;
                for await (let item of this.selectCircularList) {
                    if (item.type == 'org') {
                        let checkDup = item.userList.findIndex(x => x.mainContact.userMsgId == id)
                        if (checkDup > -1) {
                            isDup = true;
                            break;
                        }
                    }
                }
                return isDup;
            }
        },
        removeCircular(i) {
            this.selectCircularList.splice(i, 1);
        },
        async addCircular() {

            if (!this.$refs.formSelected.validate()) {
                return;
            }

            if (this.operatorSelect == "department") {
                //กรณีเป็นศูนย์/ฝ่าย ดึงข้อมูลเพิ่มเติม
                if (await this.checkDuplicate('org', this.selectCircular.id)) {
                    this.overlayError = true;
                    this.overlayErrorMessage = "ไม่สามารถเลือกรายการซ้ำได้"
                    return;
                }

                let orgData = {
                    id: this.selectCircular.id,
                    name: "",
                    position: this.selectCircular.description,
                    type: "org",
                    userList: [],
                    remark: "",
                    isShowRemark: false,
                }

                let result;
                let userObjList = [];
                await axios
                    .get(
                        this.urlApiUserMgnt +
                        "UserManagement/getUserByDepartment/" +
                        this.selectCircular.id,
                        {
                            headers: {
                                Authorization: "Bearer " + localStorage.getItem("token"),
                                API_ACCESS_KEY: this.$VUE_APP_ACCESS_KEY_USER_MNGT,
                            },
                        }
                    )
                    .then((response) => {
                        console.log('response', response)
                        result = response.data

                    })
                    .catch((error) => {
                        console.log(error)
                    })

                let ind = 0
                for await (let res of result) {
                    if (res.user != null) {
                        if (!(await this.checkDuplicate('person', res.userMngt_ID))) {
                            ind += 1
                            userObjList.push({
                                index: ind,
                                mainContact: {
                                    userMsgId: res.userMngt_ID,
                                    name: `${res.user.prefix}${res.user.firstname} ${res.user.lastname}`,
                                    positionLabel: res.position.description,
                                },
                                secretary: [],
                            })

                        }
                    }
                }
                if (userObjList.length > 0) {
                    console.log('userObjList', userObjList)
                    console.log('userObjList.length', userObjList.length)
                    orgData.userList = userObjList
                    this.selectCircularList.push(orgData);
                } else {
                    this.overlayError = true;
                    this.overlayErrorMessage = "บุคคลในหน่วยงานที่คุณเลือกถูกเลือกไปแล้ว"
                    return;
                }

            } else {
                if ((await this.checkDuplicate('person', this.selectCircular.id))) {
                    this.overlayError = true;
                    this.overlayErrorMessage = "ไม่สามารถเลือกรายการซ้ำได้"
                    return;
                }
                let personData = {
                    id: this.selectCircular.id,
                    name: this.selectCircular.description,
                    position: this.selectCircular.position,
                    type: "person",
                    userList: [{
                        index: 1,
                        mainContact: {
                            userMsgId: this.selectCircular.id,
                            name: this.selectCircular.description,
                            positionLabel: this.selectCircular.position,
                        },
                        secretary: [],
                    }],
                    remark: "",
                    isShowRemark: false,
                }
                this.selectCircularList.push(personData);
            }
            this.$refs.formSelected.resetValidation()
            this.selectCircular = null
        },
        searchItems(val) {

            if (val == null) {
                return;
            }
            let api;
            if (this.operatorSelect == "department") {
                api = this.urlApiUserMgnt + "DepartmentManagement/all?key=" + val;
            } else if (this.operatorSelect == "section") {
                api =
                    this.urlApiUserMgnt + "SegmentManagement/getsegmentall?key=" + val;
            } else {
                api = this.urlApiUserMgnt + "UserManagement/getautocompleteuser/" + val;
            }
            this.loading = true;

            this.items = [];

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                    API_ACCESS_KEY: this.$VUE_APP_ACCESS_KEY_USER_MNGT,
                },
            };
            axios
                .get(api, config)
                .then((response) => {
                    this.items.push(...response.data);
                    this.loading = false;
                })
                .catch((error) => {
                    console.log(error);
                    this.loading = false;
                });

        },
        selectCircularChanged(val) {
            this.items = [];
            this.items.push(val);
        },
        getGroup() {
            this.selectCircular = null;
            this.items = [];
            this.$refs.formSelected.resetValidation();
            if (this.operatorSelect == "department") {
                let api = this.urlApiUserMgnt + "DepartmentManagement/all";
                this.loading = true;
                let config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                        API_ACCESS_KEY: this.$VUE_APP_ACCESS_KEY_USER_MNGT,
                    },
                };
                axios
                    .get(api, config)
                    .then((response) => {
                        this.departmentMasterList.push(...response.data);
                        this.items.push(...response.data);
                        this.loading = false;
                    })
                    .catch((error) => {
                        console.log(error)
                        this.reqOfficer = false;
                        this.loading = false;
                    });
            }
            else {
                this.items = [];
                this.items.length = 0;
            }
        },
        closeDialog() {
            this.$refs.formCircularCheck.resetValidation()
            this.$refs.formSelected.resetValidation()
            this.isCloseDialog = true;
            this.circularLetter = this.circularLetterOldValue;
            this.addforwarddialog = false;
        }
    }
}
</script>